import styled from 'styled-components'

import Image from '../Image'
import Placeholder from '../../atoms/Placeholder'

const CardImage = styled(Image).attrs({
  width: 425,
  height: 250,
  imgixParams: { fit: 'crop', crop: 'focal' },
})`
  ${Placeholder} {
    width: 100%;
    height: 0;
    padding-top: 56.25%;
  }

  @media (min-width: 768px) {
    border-radius: 8px;
  }
`

export default CardImage
